import React, { PureComponent } from 'react';
import DownIcon from 'mdi-react/ChevronDownIcon';

import { UncontrolledDropdown, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import TopbarMenuItem from './TopbarMenuItem';
import { logout, updateProfile, changePassword } from '../../../redux/actions/index';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import UpdateProfile from '../../Account/Settings/UpdateProfile';
import ChangePassword from '../../Account/ChangePassword/index';

import avatar from '../../../assets/account.png'
const Ava = `${process.env.PUBLIC_URL}/img/ava.png`;

class TopbarProfile extends PureComponent {
  constructor() {
    super();
    this.state = {
      collapse: false,
      updateProfileModal: false,
      updatePasswordModal: false
    };

     this.toggleUpdateProfileModel = this.toggleUpdateProfileModel.bind(this);
     this.togglePasswordModel = this.togglePasswordModel.bind(this);
  }

  toggle = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  componentWillReceiveProps(nextProps){
        console.log("Received Props")
         console.log(nextProps)
        if (nextProps.logged_user){
             this.setState({
                updateProfileModal: false,
                updatePasswordModal: false
              });
        }
  }

  toggleUpdateProfileModel() {
        this.setState({
            updateProfileModal: !this.state.updateProfileModal
        });
  }

  togglePasswordModel() {
        this.setState({
            updatePasswordModal: !this.state.updatePasswordModal
        });
  }

  render() {
    const { collapse } = this.state;
    const { logout, logged_user } = this.props;


    return (
        <div>
            <UncontrolledDropdown className="topbar__nav-dropdown">
            <DropdownToggle className="topbar__nav-dropdown-toggle">
              <i className="fa fa-user" aria-hidden="true"/>
            </DropdownToggle>
            <DropdownMenu className="topbar__nav-dropdown-menu dropdown__menu">
              <TopbarMenuItem title={logged_user? logged_user.organization : "Account"} icon="user" />
              <TopbarMenuItem title={logged_user? logged_user.given_name : "Hello!"} icon="user" />
              <div className="topbar__menu-divider" />

              <TopbarMenuItem title="Edit Profile" onClick={this.toggleUpdateProfileModel} icon="layers" />
              <TopbarMenuItem title="Change Password" onClick={this.togglePasswordModel} icon="eye" />
              <TopbarMenuItem title="Logout" onClick={() => logout()} icon="exit" />
            </DropdownMenu>
            </UncontrolledDropdown>
            <div>
                    <Modal isOpen={this.state.updateProfileModal}
                    toggle={this.toggleUpdateProfileModel}
                    className="modal-dialog--primary">
                            <ModalHeader toggle={this.toggleUpdateProfileModel} className="modal-dialog--primary header">
                                 <span className="account__logo-accent"> Update Profile</span>
                            </ModalHeader>
                            <ModalBody>
                                <UpdateProfile onSubmit={this.props.updateProfile} data={logged_user} />
                            </ModalBody>
                    </Modal>
            </div>

            <div>
                    <Modal isOpen={this.state.updatePasswordModal}
                    toggle={this.togglePasswordModel}
                    className="modal-dialog--primary">
                            <ModalHeader toggle={this.togglePasswordModel} className="modal-dialog--primary header">
                                 <span className="account__logo-accent"> Change Password </span>
                            </ModalHeader>
                            <ModalBody>
                                <ChangePassword onSubmit={this.props.changePassword} data={logged_user} />
                            </ModalBody>
                    </Modal>
            </div>

        </div>
    );
  }
}

function mapStateToProps({ user, logged_user }) {
    return {
        user,
        logged_user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        logout,
        updateProfile,
        changePassword
    }, dispatch);
}


export default (connect(mapStateToProps, mapDispatchToProps)(TopbarProfile));